import { render } from "./DefScrollbar.vue?vue&type=template&id=acb8ad30&scoped=true"
const script = {}

import "./DefScrollbar.vue?vue&type=style&index=0&id=acb8ad30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb8ad30"]])

export default __exports__